/**
 * Created by tomers on 2/23/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/integrations/integrationsRowItemView.tmpl");
    var KpContent = require("ui.components/kpContent/kpContent");
    var Button = require("ui/button/Button");

    var IntegrationsRowAttributesView = require("manager-views/data-sources/integrations/IntegrationsRowAttributesView");

    var ManagerConfig = require("manager-assets/config/managerConfig.json");

    var IntegrationsRowItemView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        IntegrationsRowItemView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "integration-row-container",
            template: template,

            ui:{
                connectButtonContainer:'.connect-button-container',
                statusInfoContainer: ".status-info-container",
                statusActionContainer: ".status-action-container",
                editButtonContainer:'.edit-button-container',
                connectedStatusContainer: '.connected-status-container',
                disconnectButtonContainer: '.disconnect-button-container',
                connectedTitle: ".connected-title",
                editLink: ".edit-link",
                disconnectLink: ".disconnect-button-link",
                actionArea: ".action-area",
                icon: ".icon",
                itemsContainerLeft: ".items-container.left",
                itemsContainerRight: ".items-container.right",
                KPContainer: ".KPContainer"
            },

            uiComponents:{
                connectButton: {
                    type: Button,
                    options: {
                        el: "view.ui.connectButtonContainer",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        tabindex:-1
                    },
                    events: {
                        "click": "_onActionButtonClick"
                    }
                },
                disconnectLink: {
                    type: Button,
                    options: {
                        el: "view.ui.disconnectLink",
                        permutation: Button.PERMUTATION.BLUELINK,
                        text:LE.translator.translate("LEManager.dataSources.tab.integrations.link.disconnect.label"),
                        tabindex:-1
                    },
                    events: {
                        "click": "_onDisconnectButtonClick"
                    }
                },
                editLink: {
                    type: Button,
                    options: {
                        el: "view.ui.editLink",
                        permutation: Button.PERMUTATION.BLUELINK,
                        text:LE.translator.translate("LEManager.dataSources.tab.integrations.link.edit.label"),
                        tabindex:-1
                    },
                    events: {
                        "click": "_onActionButtonClick"
                    }
                }
            },

            customTemplateHelpers: function() {
                return {
                    name: this.model.getName(),
                    description: this.model.getDescription(),
                    hasEngagementAttributes: this.model.hasEngagementAttributes(),
                    hasConnectionStatus: this.model.hasConnectionStatus()
                };
            },

            initialize: function (options) {
                this._initialize(options);
            },
            onRender: function () {
                this._onRender();
            },

            _initialize: function (options) {
                this.vent = LEManager.media.channel("dataSources").vent;
                this._bindEvents();
            },

            _bindEvents: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_bindEvents");
                this.listenTo(this.model, 'change:connections', this._onConnectedStateChange);
            },

            //-----------------------------------------------------
            // onRender
            //-----------------------------------------------------

            _onRender:function () {
                LEManager.logger.debug("IntegrationsRowItemView:onRender");
                this.$el.attr("data-item-name", this.model.getLogicalName());//For automation usage
                this._configureConnectButton();
                if (this.model.hasConnectionStatus()){
                    this._renderConnectionBlock();
                }
                else if (this.model.hasEngagementAttributes()){
                    this._renderAttributesBlock();
                }
                if (this.model.hasKPWithDescription()){
                    this._renderKP();
                }
            },

            _configureConnectButton: function(){
                this.uiComponents.connectButton.setText(this.model.getButtonName());
                if (!this.model.isEditEnabled()){
                    this.uiComponents.connectButton.setEnabled(false);
                    this.uiComponents.connectButton.setTooltip(LE.translator.translate("LEManager.dataSources.tab.integrations.button.configure.error.unauthorized"), Button.TOOLTIP_ALIGN.RIGHT);
                    this.uiComponents.editLink.setEnabled(false);
                }
            },

            _onConnectedStateChange: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_onConnectedStateChange");
                if (!this.isClosed) {
                    this._renderConnectionBlock();
                }
            },

            _onActionButtonClick: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_onActionButtonClick");
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.root.TRIGGERING.ACTION_BUTTON_CLICKED, this.model);
            },

            _onDisconnectButtonClick: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_onDisconnectButtonClick");
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.webAnalytics.TRIGGERING.DISCONNECT_CONNECTORS_CLICK, this.model);
            },

            _renderConnectionBlock: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_renderConnectionBlock");
                var connectionStatus = this.model.getConnectionStatus();
                LEManager.logger.debug("IntegrationsRowItemView:_renderConnectionBlock - connectionStatus: " + connectionStatus + " for " + this.model.getName());
                switch (connectionStatus)  {
                    case this.model.CONNECTION_STATUS.UNKNOWN:
                        this._displayConnectionStatusUnknown();
                        break;
                    case this.model.CONNECTION_STATUS.NONE:
                        this._displayConnectionStatusNone();
                        break;
                    case this.model.CONNECTION_STATUS.FULLY:
                        this._displayConnectionStatusFull();
                        break;
                }
            },

            _renderAttributesBlock: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_renderAttributesBlock");
                this.uiComponents.host$.createAndRender("itemsListLeft", {
                    type:IntegrationsRowAttributesView,
                    options:{
                        el: this.ui.itemsContainerLeft,
                        collection: this.model.getLeftAttributesCollection()
                    }
                });
                this.uiComponents.host$.createAndRender("itemsListRight", {
                    type:IntegrationsRowAttributesView,
                    options:{
                        el: this.ui.itemsContainerRight,
                        collection: this.model.getRightAttributesCollection()
                    }
                });
            },

            _renderKP: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_renderKP");
                this.uiComponents.host$.createAndRender("kpContent", {
                    type : KpContent,
                    options : {
                        container: "view.ui.KPContainer",
                        KPLink: this.model.getDescrSlugCaption(),
                        kpID: this.model.getDescrSlugId(),
                        showKPIcon: true
                    }
                });
            },

            _displayConnectionStatusUnknown: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_displayConnectionStatusUnknown");
                if (this.model.isConnectActionType()){
                    this._displayStatusActionField(false);
                }
            },

            _displayConnectionStatusNone: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_displayConnectionStatusNone");
                this.ui.connectedTitle.html("");
                this._displayStatusInfoField(true);
                this._displayStatusActionField(true);
                this._displayConnectButtonContainer(true);
                this._displayEditButtonContainer(false);
                this._displayDisconnectButtonContainer(false);
                this.uiComponents.connectButton.setState(this.model.isEditEnabled() ? Button.STATES.ENABLED : Button.STATES.DISABLED);
                this.ui.statusInfoContainer.removeClass(this.model.CONNECTION_STATUS.FULLY);
                this.ui.statusInfoContainer.addClass(this.model.CONNECTION_STATUS.NONE);
                this._displayConnectionIcon(false);
                this.ui.connectedTitle.html(this.model.getConnectionStatusName());
                this.ui.statusActionContainer.removeClass("left").removeClass("center").addClass("center");
            },

            _displayConnectionStatusFull: function(){
                LEManager.logger.debug("IntegrationsRowItemView:_displayConnectionStatusFull");
                this._displayStatusInfoField(true);
                this._displayStatusActionField(true);
                this._displayConnectButtonContainer(false);
                if (this.model.isGoogleAnalytics()){
                    this._displayEditButtonContainer(false);
                    this._displayDisconnectButtonContainer(true);
                }
                else {
                    this._displayEditButtonContainer(true);
                    this._displayDisconnectButtonContainer(false);
                }
                this.ui.statusInfoContainer.removeClass(this.model.CONNECTION_STATUS.NONE);
                this.ui.statusInfoContainer.addClass(this.model.CONNECTION_STATUS.FULLY);
                this._displayConnectionIcon(true);
                this.ui.connectedTitle.html(this.model.getConnectionStatusName());
                this.ui.statusActionContainer.removeClass("left").removeClass("right").addClass("center");
            },

            _displayConnectionIcon: function(show){
                LEManager.logger.debug("IntegrationsRowItemView:_displayConnectionIcon - show: " + show);
                if (show) {
                    this.ui.icon.show();
                }
                else {
                    this.ui.icon.hide();
                }
            },

            _displayStatusInfoField: function(show){
                LEManager.logger.debug("IntegrationsRowItemView:_displayStatusInfoField - show: " + show);
                if (show){
                    this.ui.statusInfoContainer.show();
                }
                else{
                    this.ui.statusInfoContainer.hide();
                }
            },

            _displayStatusActionField: function(show){
                LEManager.logger.debug("IntegrationsRowItemView:_displayStatusActionField - show: " + show);
                if (show){
                    this.ui.statusActionContainer.show();
                }
                else{
                    this.ui.statusActionContainer.hide();
                }
            },

            _displayConnectButtonContainer: function(show){
                LEManager.logger.debug("IntegrationsRowItemView:_displayConnectButtonContainer - show: " + show);
                if (show){
                    this.ui.connectButtonContainer.show();
                }
                else{
                    this.ui.connectButtonContainer.hide();
                }
            },

            _displayEditButtonContainer: function(show){
                LEManager.logger.debug("IntegrationsRowItemView:_displayEditButtonContainer - show: " + show);
                if (show){
                    this.ui.editButtonContainer.removeClass("hide").addClass("show-inline");
                }
                else {
                    this.ui.editButtonContainer.removeClass("show-inline").addClass("hide");
                }
            },

            _displayDisconnectButtonContainer: function(show){
                LEManager.logger.debug("IntegrationsRowItemView:_displayDisconnectButtonContainer - show: " + show);
                if (show){
                    this.ui.disconnectButtonContainer.removeClass("hide").addClass("show-inline");
                }
                else {
                    this.ui.disconnectButtonContainer.removeClass("show-inline").addClass("hide");
                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return IntegrationsRowItemView;
});
